<script setup lang="ts">
interface HotelDescriptionMarkdownStyles {
  openingParagraph: boolean;
}

const props = defineProps<HotelDescriptionMarkdownStyles>();
</script>

<template>
  <div
    class="markdown-styles"
    :class="{ 'opening-paragraph': props.openingParagraph }"
  >
    <slot />
  </div>
</template>

<style scoped lang="scss">
.markdown-styles {
  @include font-body-m-light;
  color: var(--color-neutral-70);

  :deep(h3) {
    @include font-label-m-bold;
    color: var(--color-neutral-70);
    margin-top: var(--spacing-32);
    margin-bottom: var(--spacing-16);
  }

  :deep(div) {
    @include font-body-l-light;
    color: var(--color-neutral-70);
    margin: var(--spacing-16) 0;
  }

  :deep(p) {
    @include font-body-l-light;
    color: var(--color-neutral-70);
    margin: var(--spacing-16) 0;
  }

  :deep(ul) {
    padding-left: var(--spacing-32);
    margin: var(--spacing-32) 0;
  }

  :deep(li) {
    @include font-body-l-light;
    color: var(--color-neutral-70);
    margin: var(--spacing-16) 0;
  }

  &.opening-paragraph {
    :deep(ul) {
      list-style-type: disc;
      padding-left: var(--spacing-16);
      margin: var(--spacing-16) 0;
    }

    :deep(li) {
      @include font-label-m-light;
      color: var(--color-neutral-70);
      margin: var(--spacing-16) 0;
    }

    :deep(p) {
      margin-top: var(--spacing-16);
      margin-bottom: var(--spacing-32);
    }
  }
}
</style>
